import { debounce } from 'lodash';
import React, { FC, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setTimeKeeperDevice, updateProps } from '../../../contextRedux/TimeKeeperDevice/TimeKeeperDeviceModel';
import { SearchInput } from '../../../customComponents/input/SearchInput';
import { CustomTable } from '../../../customComponents/table/CustomTable';
import { RootState } from '../../../store';
import { TimeKeeperDeviceColumn } from './TimeKeeperDeviceColumn';

const TimeKeeperDeviceTable: FC<any> = () => {
  const dispatch = useDispatch();

  const reduxTimeKeeperDevice = useSelector((state: RootState) => state.models?.timeKeeperDevice);
  const timeKeeperDevices = useSelector((state: RootState) => state.store?.timeKeeperDevice.data ?? []);

  const pageSizes = [10, 20, 30, 50];
  const currentPage = Math.floor(reduxTimeKeeperDevice.props.skip / reduxTimeKeeperDevice.props.take) + 1;

  const debouncedSearch = useCallback(
    debounce((value: string) => {
      dispatch(updateProps({ field: 'searchTerm', value }));
      dispatch(updateProps({ field: 'skip', value: 0 }));
    }, 500),
    [dispatch]
  );

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    debouncedSearch(e.target.value);
  };

  const handleEdit = (record: any) => {
    dispatch(setTimeKeeperDevice(record));
    dispatch(updateProps({ field: 'isModalVisible', value: true }));
  };

  const paginationConfig = {
    current: currentPage,
    pageSize: reduxTimeKeeperDevice.props.take,
    total: reduxTimeKeeperDevice.props.totalItems,
    onChange: (page: number, pageSize: number) => {
      const skipValue = (page - 1) * pageSize;
      dispatch(updateProps({ field: 'skip', value: skipValue }));
      dispatch(updateProps({ field: 'take', value: pageSize }));
    },
    showSizeChanger: true,
    pageSizeOptions: pageSizes.map((size) => size.toString()),
    onShowSizeChange: (_current: number, size: number) => {
      dispatch(updateProps({ field: 'skip', value: 0 }));
      dispatch(updateProps({ field: 'take', value: size }));
    },
    showQuickJumper: false,
  };

  return (
    <>
      <SearchInput
        placeholder='Search...'
        defaultValue={reduxTimeKeeperDevice.props.searchTerm}
        onChange={handleSearch}
        style={{ marginBottom: 10 }}
      />
      <CustomTable
        initialDataSource={timeKeeperDevices}
        pagination={paginationConfig}
        rowKey='id'
        className='table'
        columns={TimeKeeperDeviceColumn(handleEdit)}
      />
    </>
  );
};

export default TimeKeeperDeviceTable;
